import { Row, Col, Card, Badge, Form, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { store } from 'Store';
import { useDispatch } from "react-redux";
import { useEffect, useRef, useReducer } from "react";
import { FormTextInput } from "Components/Forms/FormInput";
import { generateCtRpt, loadFormInfo, validateCtRpt } from "./CommentReportAxiosFuncs";
import { formInfoReducer, ACTIONS } from "./CommentReportFormDataReducer";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { IconTextButton, TextButton } from "Components/Button";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { applyDateSelectorFormat } from "Utils/utilityFunctions";
import { ICONS } from "Utils/icons";

/* mapping field errors */
const nameConverter = {
  "commentTypeId": "selectedCtType",
  "reportFileName": "fileName",
  "startDate": "startDate",
  "endDate": "endDate"
}

const CommentReport = () => {

  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialState = {
    data: '',
    loading: true,
    error: null,
  };
  const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);

  const formFieldDisplay = {
    selectedCtType: {
      type: 'select',
      id: 'selectedCtType',
      name: 'selectedCtType',
      display: {
        label: 'Choose Comment Type',
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    startDate: {
      type: 'date',
      id: 'startDate',
      name: 'startDate',
      display: {
        label: 'Start Date',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    endDate: {
      type: 'date',
      id: 'endDate',
      name: 'endDate',
      display: {
        label: 'End Date',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    fileName: {
      type: 'text',
      id: 'fileName',
      name: 'fileName',
      display: {
        label: 'Report File Name',
        description: <>Report Name should not exceed 100 characters in length. <br /> Report Name should not have improper characters \ / : & * ? " &lt; &gt; | .</>,
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    }
  }

  var ctTypesListValues = (ctTypeList) => {
    var objArr = [];
    objArr.push({
      index: 0,
      value: "0_All Comment Types",
      title: "Select Comment Type",
      displayValue: "All Comment Types",
      isSelected: true
    });

    for (var i = 0; i < ctTypeList.length; i++) {
      var x = ctTypeList[i];
      objArr.push({
        index: x.id,
        value: x.id + "_" + x.shortName,
        title: "Select Comment Type " + x.shortName,
        displayValue: x.shortName,
        isSelected: false
      });
    }

    objArr.push({
      index: 1000,
      value: "-1_General Comments",
      title: "Select Comment Type General Comments",
      displayValue: "General Comments",
      isSelected: false
    });

    return objArr;
  };

  /** Handle dropdown change */
  const handleSelectChange = (e) => {
    formInfoDispatch({
      type: ACTIONS.SELECT_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  /*Handle text/date change*/
  const handleInputDateChange = (e) => {
    const val = applyDateSelectorFormat(e.target.value);

    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: val,
      name: e.target.name
    });
  }

  const handleInputTextChange = (e) => {
    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: e.target.value,
      name: e.target.name
    });
  }

  /** Display field errors */
  var dispErrors = (fieldName) => {
    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];
    return (
      <div>
        {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
          <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
            <div>{errorText}</div>
          </Stack>

        ) : null}
      </div>
    );
  }

  /**Render the input label */
  var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {

    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];

    if (alignment == Row) {
      if (multi == true) {
        return (
          <Col hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {<span className="me-2">{dispData.display.label}</span>}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Col>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden} column
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {<span className="me-2">{dispData.display.label}</span>}
            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
    else {
      if (multi == true) {
        return (
          <Row hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {dispData.display.label}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Row>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {dispData.display.label}
            {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }

    }

  };

  /** get filed value in the response by key */
  function getFieldValue (fieldName, data) {
    var values = data[fieldName];
    var dispValues = formFieldDisplay[fieldName];

    if (formInfo.loading) {
      return '';
    }
    else {
      var type = dispValues.type;
      switch (type) {
        case "text":
          if (values.value != null) {
            return values.value;
          }
          return "";
        case "date":
          if (values.value != null) {
            var split = values.value.split('-');
            if (split.length == 3) {
              return split[1] + '/' + split[2] + '/' + split[0];
            }
            return values.value;
          }
          return "";
        case "select":
          if (values != null) {
            var arr = values.options;
            for (var x = 0; x < arr.length; x++) {
              var val = arr[x];
              if (val.isSelected) {
                return val.value;
              }
            }
          }
          return null;
      }
    }
  }

  /**Build field error list */
  function addErrorMessages (fieldName, errorFieldName, data, isFirst) {
    var d = data.fieldErrors;
    var values = d[errorFieldName];

    if (values != null) {
      var field = formFieldDisplay[fieldName];
      var type = field.type;
      var err = values.errorMessages;

      if (isFirst == true) {
        (field.InputRef).current.focus();
        //console.log("ISFIRST");
      }

      switch (type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "date":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
      }

    }
  }

  /**Clear error messages  */
  function clearErrorMessages (data) {
    for (const [key, value] of Object.entries(data)) {
      var t = formFieldDisplay[key];
      var fieldName = key;
      switch (t.type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "date":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
      }
    }
  }

  const handleCancel = () => {
    navigate("/dashboard");
  }

  useEffect(() => {
    loadFormInfo(ACTIONS, formInfoDispatch, handleSelectChange,
      handleInputTextChange, handleInputDateChange, { ctTypesListValues },
      token)
      .catch((error) => {
        const payload = error?.data ?? error;
        setGlobalErrorStatus({
          dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
  }, []);

  const handleFileDownload = async () => {
    const validation = await validateCtRpt(token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue).catch((error) => {
      // //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });

    //console.log("handle ct report download validation response", validation);
    if (validation.data?.status === 1) {
      const res = await generateCtRpt(formInfo, "Bearer " + loginState.token, getFieldValue).catch((error) => {
        // //console.log("error handleFileDownload()", error);
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
      // //console.log("after handleFileDownload", res);

      if (res?.status?.code === 1) {
        // get filename from the res content-disposition
        const fileName = res.data.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        // //console.log("after handleFileDownload filename", fileName);
        let url = window.URL.createObjectURL(res.data.data);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element  
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: res.data?.status?.text
        });
      }
    }
  }

  return (

    <Row>
      {formInfo.loading ? null :
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Common Formats Comment Report</h1>
              <p>
                This report is used to download the comments submitted by the general public regarding the Common
                Formats definitions. If no dates are provided, the report will be generated showing all comments submitted.
              </p>
              <p> Answer the questions below to create your report. </p>
              <br />
              <Form>
                <FormTextInput orgType={"Admin"} fieldName="selectedCtType" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Admin"} fieldName="startDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Admin"} fieldName="endDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Admin"} fieldName="fileName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <br />
                <Col className="d-flex gap-4">
                  {/* Submit Button */}
                  <IconTextButton
                    className="reverse"
                    icon={ICONS.download}
                    onClick={handleFileDownload}
                    variant="normal"
                    content={"Generate Report"}
                  />
                  {/* Cancel Button */}
                  <TextButton
                    variant="outline"
                    onClick={handleCancel}
                    content={"Cancel"}
                  >
                  </TextButton>
                </Col>
              </Form>
            </Card.Body>
          </Card>
        </Col>}
    </Row >
  )
}

export default CommentReport;